import React from 'react';
import ContentLoader from 'react-content-loader';

const LoaderDetails = ({ pageRange = 10 }) => {
  const height = 50 * (pageRange + 1);
  const body = new Array(pageRange + 1).fill(null).map((i, ind) => {
    let yStrip = ind ? 40 * ind + 8 : 12;

    if (ind === 0) {
      yStrip = 17;
    } else if (ind === 1) {
      yStrip = 70;
    } else {
      yStrip = 40 * (ind - 1) + 70;
    }

    return (
      <React.Fragment key={ind}>
        {ind ? (
          <>
            <rect x="30" y={yStrip} rx="3" ry="3" width="14" height="14" />
            <rect x="54" y={yStrip} rx="3" ry="3" width="8" height="12" />
            <rect x="82" y={yStrip} rx="3" ry="3" width="105" height="14" />
            <rect x="208" y={yStrip} rx="3" ry="3" width="140" height="12" />
            <rect x="364" y={yStrip} rx="3" ry="3" width="100" height="12" />
            <rect x="552" y={yStrip} rx="3" ry="3" width="10" height="12" />
            <rect x="680" y={yStrip} rx="3" ry="3" width="5" height="12" />
            <rect x="786" y={yStrip} rx="3" ry="3" width="60" height="12" />
            <rect x="926" y={yStrip} rx="3" ry="3" width="60" height="12" />
            <rect x="1123" y={yStrip} rx="3" ry="3" width="60" height="12" />
          </>
        ) : (
          <>
            <rect x="82" y={yStrip + 9} rx="3" ry="3" width="45" height="14" />
            <rect x="208" y={yStrip + 9} rx="3" ry="3" width="48" height="12" />
            <rect x="364" y={yStrip + 9} rx="3" ry="3" width="100" height="12" />
            <rect x="552" y={yStrip + 9} rx="3" ry="3" width="108" height="12" />
            <rect x="680" y={yStrip + 9} rx="3" ry="3" width="80" height="12" />
            <rect x="786" y={yStrip} rx="3" ry="3" width="118" height="24" />
            <rect x="926" y={yStrip} rx="3" ry="3" width="110" height="24" />
            <rect x="1123" y={yStrip} rx="3" ry="3" width="100" height="24" />
          </>
        )}
      </React.Fragment>
    );
  });

  return (
    <ContentLoader
      speed={2}
      width={1330}
      height={597}
      viewBox={`0 0 1330 ${597}`}
      backgroundColor="#f3f3f3"
      foregroundColor="#ecebeb">
      <>
        {body}
        <rect x="30" y="470" rx="3" ry="3" width="1242" height="35" />
        <rect x="67" y="538" rx="3" ry="3" width="40" height="12" />
        <rect x="786" y="538" rx="3" ry="3" width="135" height="12" />
        <rect x="1123" y="538" rx="3" ry="3" width="100" height="12" />
        <rect x="786" y="561" rx="3" ry="3" width="150" height="12" />
        <rect x="1123" y="561" rx="3" ry="3" width="100" height="12" />
      </>
    </ContentLoader>
  );
};

export default LoaderDetails;
